export class AxiosEnum {
  static readonly GET = new AxiosEnum('get');
  static readonly POST = new AxiosEnum('post');
  static readonly PATCH = new AxiosEnum('patch');
  static readonly PUT = new AxiosEnum('put');
  static readonly DELETE = new AxiosEnum('delete');

  private constructor(readonly value: string) {}
}
